import { render, staticRenderFns } from "./ReturnInfo.vue?vue&type=template&id=f922f97c&scoped=true&"
import script from "./ReturnInfo.vue?vue&type=script&lang=ts&"
export * from "./ReturnInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnInfo.vue?vue&type=style&index=0&id=f922f97c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f922f97c",
  null
  
)

export default component.exports